import { APP_INITIALIZER, Inject, Injectable, InjectionToken, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // KEEP THIS
// REMOVED: NoopAnimationsModule (Conflicted with BrowserAnimationsModule)

import { NgReduxModule, NgRedux, DevToolsExtension } from '@angular-redux/store';
import { rootReducer, ArchitectUIState } from './ThemeOptions/store';
import { ConfigActions } from './ThemeOptions/store/config.actions';
import { AppRoutingModule } from './app-routing.module';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { AppComponent } from './app.component';

import { MatIconModule } from '@angular/material/icon';
import { LayoutModule } from '@angular/cdk/layout';
import { BrowserModule } from '@angular/platform-browser';
import { AgmCoreModule } from '@agm/core';

// BOOTSTRAP COMPONENTS
import { PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

// LAYOUT
import { BaseLayoutComponent } from './Layout/base-layout/base-layout.component';
import { PageTitleComponent } from './Layout/base-layout/Components/page-title/page-title.component';

// HEADER
import { HeaderComponent } from './Layout/base-layout/Components/header/header.component';
import { SearchBoxComponent } from './Layout/base-layout/Components/header/elements/search-box/search-box.component';
import { UserBoxComponent } from './Layout/base-layout/Components/header/elements/user-box/user-box.component';

// SIDEBAR
import { SidebarComponent } from './Layout/base-layout/Components/header/sidebar/sidebar.component';
import { LogoComponent } from './Layout/base-layout/Components/header/sidebar/elements/logo/logo.component';
import { DynamicSidebarListComponent } from './Layout/base-layout/Components/header/dynamic-sidebar-list/dynamic-sidebar-list.component';
import { DynamicSidebarItemComponent } from './Layout/base-layout/Components/header/dynamic-sidebar-item/dynamic-sidebar-item.component';

// FOOTER
import { FooterComponent } from './Layout/base-layout/Components/footer/footer.component';

// Pages
import { AngularResizedEventModule } from 'angular-resize-event';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { KeycloakService } from 'keycloak-angular';
import { SampleService } from './Shared/Services/sample.service';

// UPDATED IMPORT: We only import the function now
import { initializeKeycloak } from './AppInitialiser/app-init';

import { WINDOW_PROVIDERS } from './window.providers';
import { SharedModule } from './Shared/shared.module';
import { InteractionService } from './Shared/Services/interaction.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReportingComponent } from './Pages/House-maid-reporting/reporting/reporting.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";

// REMOVED: import loader from "@angular-devkit/..." (Caused runtime crashes)

import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { MatSelectModule } from "@angular/material/select";

import localeFr from '@angular/common/locales/fr';
import { DatePipe, registerLocaleData } from '@angular/common';
import { AuthInterceptor } from "./Guards/auth-interceptor.interceptor";
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { FastCheckInComponent } from './Pages/Front-desk/fast-check-in/fast-check-in.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { UserMenusComponent } from './Pages/admin/components/user-menus/user-menus.component';
import { MatDividerModule } from '@angular/material/divider';

registerLocaleData(localeFr, 'fr');

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
  constructor(@Inject(DEFAULT_TIMEOUT) protected defaultTimeout: number) {}
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const timeoutValue = req.headers.get('timeout') || this.defaultTimeout;
    const timeoutValueNumeric = Number(timeoutValue);
    return next.handle(req).pipe(timeout(timeoutValueNumeric));
  }
}

@NgModule({
  declarations: [
    AppComponent,
    BaseLayoutComponent,
    PageTitleComponent,
    HeaderComponent,
    SearchBoxComponent,
    UserBoxComponent,
    SidebarComponent,
    LogoComponent,
    FooterComponent,
    ReportingComponent,
    DynamicSidebarListComponent,
    DynamicSidebarItemComponent,
    FastCheckInComponent, 
  ],
  imports: [
    SharedModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule, // ONLY This one.
    // NoopAnimationsModule, // DELETED
    NgReduxModule,
    LoadingBarRouterModule,
    PerfectScrollbarModule,
    FontAwesomeModule,
    FormsModule,
    NgbModule,
    HttpClientModule,
    AngularResizedEventModule,
    AngularSlickgridModule.forRoot(),
    AppRoutingModule,
    LayoutModule,
    MatIconModule,
    MatAutocompleteModule,
    AgmCoreModule.forRoot({ apiKey: 'AIzaSyDCryrFC2s7_OHNwryXVFEZyTy1wiwFlvc' }),
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
 
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,

  ],
  providers: [
    WINDOW_PROVIDERS,
    KeycloakService,
    // REMOVED: KeyclockInit (No longer a provider, logic moved to factory)
    ConfigActions,
    InteractionService,
    SampleService,
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    // REMOVED: The duplicate APP_INITIALIZER for KeyclockInit.load()
    
    // KEEP: The Single, Correct Initializer
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService, SampleService], // Added SampleService dependency
    },
    { provide: LOCALE_ID, useValue: 'fr' }
  ],
  exports: [
    MatInputModule
  ],
  bootstrap: [
    AppComponent,
  ]
})
export class AppModule {
  constructor(private ngRedux: NgRedux<ArchitectUIState>, private devTool: DevToolsExtension) {
    this.ngRedux.configureStore(
      rootReducer,
      {} as ArchitectUIState,
      [],
      [devTool.isEnabled() ? devTool.enhancer() : f => f]
    );
  }
}